import { render } from "./DiyCommodityMangeTable.vue?vue&type=template&id=073ef53c&scoped=true"
import script from "./DiyCommodityMangeTable.vue?vue&type=script&lang=js"
export * from "./DiyCommodityMangeTable.vue?vue&type=script&lang=js"

import "./DiyCommodityMangeTable.vue?vue&type=style&index=0&id=073ef53c&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073ef53c"]])

export default __exports__